import React from 'react';

// Reusable functions for react-table.
export function TableHeader(headerGroups) {
  return headerGroups.map(headerGroup => (
    <tr {...headerGroup.getHeaderGroupProps()}>
      {headerGroup.headers.map(column => (
        <th {...column.getHeaderProps()}>{column.render('Header')}</th>
      ))}
    </tr>
  ));
}

export function TableFilter(headerGroups, disabled=null) {
  return headerGroups.map(headerGroup => (
    <tr {...headerGroup.getHeaderGroupProps()}>
      {headerGroup.headers.map(column => {
        let showFilter = column.canFilter;
        if (disabled != null) {
          showFilter &= !disabled(column);
        }
        return (<th {...column.getHeaderProps()}>{showFilter ? column.render('Filter') : null}</th>);
      })}
    </tr>
  ));
}

export function TableBody(rows, prepareRow, additionalCellProps=null) {
  return rows.map(
    (row, i) =>
      prepareRow(row) || (
        <tr {...row.getRowProps()}>
          {row.cells.map(cell => {
            const props = additionalCellProps != null ? additionalCellProps(cell) : null;
            return (<td {...cell.getCellProps()} {...props}>{cell.render('Cell')}</td>);
          })}
        </tr>
      )
  );
}

export function TextColumnFilter(className) {
  return ({column: { filterValue, preFilteredRows, setFilter }}) => (
    <input
      {...{className}}
      value={filterValue || ''}
      onChange={e => setFilter(e.target.value || undefined)}
      placeholder="Search"
    />
  );
}

export function SelectColumnFilter(options, className) {
  return ({column: { filterValue, preFilteredRows, setFilter }}) => (
    <select
      {...{className}}
      value={filterValue}
      onChange={e => setFilter(e.target.value || undefined)}
    >
      <option value="">All</option>
      {options.map(({label, value}) => <option key={value} value={value}>{label}</option>)}
    </select>
  );
}
